import { Box, Button, Progress, Stack, Text } from '@lego/klik-ui';
import { StatusCircleCheckSolid, StatusErrorBold } from '@lego/klik-ui/icons';

type UploadStatus = 'idle' | 'uploading' | 'success' | 'error';

type UploadProgressBarProps = {
  fileName?: string;
  status: UploadStatus;
  progress: number;
  errorMessage?: string;
  onGoBack?: () => void;
};

export const UploadProgressBar = ({
  fileName,
  status,
  progress,
  errorMessage,
  onGoBack,
}: UploadProgressBarProps) => {
  return (
    <Box my={3} textAlign="left" w="100%">
      <Box alignItems="center" display="flex" gap={2}>
        <Text fontSize="md">{fileName}</Text>
        {status === 'success' && <StatusCircleCheckSolid color="success.500" />}
        {status === 'error' && <StatusErrorBold color="error.500" />}
      </Box>
      {status === 'error' ? (
        <Stack alignItems={'start'} gap={4}>
          <Text color="error.500" fontSize="sm" mt={1} whiteSpace="pre-line">
            {errorMessage || 'An error occurred during upload.'}
          </Text>

          {onGoBack && (
            <Button onClick={onGoBack} size="sm" variant="outline">
              Try again
            </Button>
          )}
        </Stack>
      ) : (
        <Progress value={progress} />
      )}
    </Box>
  );
};
